import { addElement, empty } from 'sesajstools/dom'

// ces imports ne fonctionnent que lorsqu'on est compilé dans une sésathèque (cf son webpack.config qui donne le chemin de client/…)
import page from 'client/page'

let isLoaded

/**
 * Affiche une ressource am (aides mathenpoche : animations flash, sans réponse de l'élève)
 * @service plugins/am/display
 * @param {Ressource}      ressource  L'objet ressource
 * @param {displayOptions} options    Les options après init
 * @param {errorCallback}  next       La fct à appeler quand le swf sera chargé (sans argument ou avec une erreur)
 */
export function display (ressource, options, next) {
  try {
    const container = options.container
    if (!container) throw new Error('Il faut passer dans les options un conteneur html pour afficher cette ressource')
    const resultat = {
      score: 1,
      fin: true,
      deferSync: true
    }
    let isResultatSend = false
    // on enverra le résultat à la fermeture (si y'a eu un chargement, isLoaded sert de flag)
    if (options.resultatCallback && window.addEventListener) {
      window.addEventListener('unload', function () {
        if (isLoaded && !isResultatSend) options.resultatCallback(resultat)
        // sinon le swf n'a pas été chargé (ou on a déjà cliqué sur "vu"), on envoie rien
      })
    }
    const params = ressource.parametres

    // les params minimaux
    if (!ressource.oid || !ressource.titre || !params) {
      throw new Error('Paramètres manquants')
    }

    // On réinitialise le conteneur
    empty(container)
    const iframe = addElement(container, 'iframe', { style: { overflow: 'auto', minWidth: '735px', minHeight: '450px' } })
    if (options.resultatCallback) {
      iframe.addEventListener('load', () => {
        page.addBoutonVu(() => {
          isResultatSend = true
          options.resultatCallback(resultat)
        })
      })
    }
    page.autosize(iframe)
    const lang = params.mep_langue_id ?? 'fr'
    iframe.src = `/plugins/am/display.html?lang=${lang}&id=${ressource.idOrigine}`
  } catch (error) {
    if (next) next(error)
    else page.addError(error)
  }
}

// pas d'export par défaut… c'était construit comme ça
